import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Linkedin, Twitter, ArrowRight } from 'lucide-react';
import { profileData } from '../data/mock';

const Hero = () => {
  return (
    <section className="min-h-screen flex items-center justify-center px-6 pt-20">
      <div className="max-w-4xl mx-auto text-center">
        <div className="animate-fadeIn">
          <p className="text-blue-600 dark:text-blue-400 text-sm font-medium mb-4 tracking-wide animate-slideDown">
            {profileData.hero.greeting}
          </p>
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 dark:text-white mb-6 leading-tight animate-slideUp">
            {profileData.hero.name}
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 dark:text-gray-300 mb-4 font-medium animate-slideUp animation-delay-200">
            {profileData.hero.tagline}
          </p>
          <p className="text-lg md:text-xl text-gray-500 dark:text-gray-400 mb-12 max-w-2xl mx-auto animate-slideUp animation-delay-300">
            {profileData.hero.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12 animate-slideUp animation-delay-400">
            <Link
              to="/contact"
              className="group inline-flex items-center px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
            >
              Get in Touch
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
            <a
              href="#projects"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#projects')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center px-8 py-3 border-2 border-gray-300 dark:border-gray-600 hover:border-blue-600 dark:hover:border-blue-400 text-gray-700 dark:text-gray-300 rounded-full transition-all duration-300 hover:shadow-lg"
            >
              View Projects
            </a>
          </div>

          <div className="flex items-center justify-center space-x-6 animate-slideUp animation-delay-500">
            <a
              href={profileData.social.github}
              target="_blank"
              rel="noopener noreferrer"
              className="group p-3 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-900 dark:hover:bg-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
              aria-label="GitHub"
            >
              <Github className="w-6 h-6 text-gray-700 dark:text-gray-300 group-hover:text-white dark:group-hover:text-gray-900 transition-colors duration-300" />
            </a>
            <a
              href={profileData.social.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="group p-3 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-[#0A66C2] transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-6 h-6 text-gray-700 dark:text-gray-300 group-hover:text-white transition-colors duration-300" />
            </a>
            <a
              href={profileData.social.twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="group p-3 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-black dark:hover:bg-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
              aria-label="X (Twitter)"
            >
              <svg 
                className="w-6 h-6 text-gray-700 dark:text-gray-300 group-hover:text-white dark:group-hover:text-black transition-colors duration-300" 
                viewBox="0 0 24 24" 
                fill="currentColor"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;